import { render, staticRenderFns } from "./YoutubeSettingsModal.vue?vue&type=template&id=45b89a38"
import script from "./YoutubeSettingsModal.vue?vue&type=script&lang=js"
export * from "./YoutubeSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./YoutubeSettingsModal.vue?vue&type=style&index=0&id=45b89a38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports